// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"undo-cancel-toast_wrapper__SeT2N","info":"undo-cancel-toast_info__VVSTs","buttons":"undo-cancel-toast_buttons__GNmp_","no_thanks":"undo-cancel-toast_no_thanks__G6Dkg"};